import FormErrors from './errors';

export default class VueForm {
  constructor(data) {
    this.data = data;
    this.errors = new FormErrors();
    this.busy = false;
    this.successful = false;
  }

  startProcessing() {
    this.errors.forget();
    this.busy = true;
    this.successful = false;
  };

  finishProcessing() {
    this.busy = false;
    this.successful = true;
  };

  resetStatus() {
    this.errors.forget();
    this.busy = false;
    this.successful = false;
  };

  setErrors(errors) {
    this.busy = false;
    this.errors.set(errors);
  };

  post(uri, config = {}) {
    return this.sendForm({method: 'post', uri, data: this.data, config})
  }

  put(uri, config = {}) {
    return this.sendForm({method: 'put', uri, data: this.data, config})
  }

  sendForm({method, uri, config, data}) {
    return new Promise((resolve, reject) => {
      this.startProcessing();

      window.axios[method](uri, data, config)
        .then(response => {
          this.finishProcessing();

          resolve(response.data);
        })
        .catch(errors => {
          this.setErrors(errors.response.data.errors);

          reject(errors.response.data);
        });
    });
  }
};
